module.exports = __webpack_public_path__ + "img/package-added-th.9314c1b.png";